"use strict";
// Changed something here, change it in the locales and other projects.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSPORT_VALIDATION_REGEX = exports.FIO_VALIDATION_REGEX = exports.EMAIL_VALIDATION_REGEX = exports.EMAIL_VALIDATION_FORMAT_REGEX = exports.EAuthPagesAndModal = void 0;
var EAuthPagesAndModal;
(function (EAuthPagesAndModal) {
    EAuthPagesAndModal["SignIn"] = "log in";
    EAuthPagesAndModal["ConfirmSMS"] = "code from sms";
    EAuthPagesAndModal["FastSignUp"] = "sms registration";
    EAuthPagesAndModal["FullSignUp"] = "full registration";
    EAuthPagesAndModal["Recovery"] = "restore your login";
})(EAuthPagesAndModal || (exports.EAuthPagesAndModal = EAuthPagesAndModal = {}));
exports.EMAIL_VALIDATION_FORMAT_REGEX = /^\S+@\S+\.\S+$/;
exports.EMAIL_VALIDATION_REGEX = /^[0-9a-zA-ZА-Яа-я][А-ЯA-Zа-яa-z0-9._-]+@[А-Яа-яA-Za-z0-9]+\.[А-Яа-яA-Za-z]{2,6}\b/;
exports.FIO_VALIDATION_REGEX = /^[a-zA-Zа-яА-Я ё Ё Әә Ғғ Ққ Ңң Өө Ұұ Үү Һһ Іі 0-9- / ]+$/;
exports.PASSPORT_VALIDATION_REGEX = /^[A-Za-z0-9№-\s]+$/;
//# sourceMappingURL=auth.js.map